import React from "react";
import { useGlobalStore } from "../hooks/useGlobalStore";
import { useStorageCache } from "../hooks/useStorageCache";
import { constants } from "src/shared/constants";
import { useTeamConfig } from "../components/TeamConfigProvider";
import { FullScreenPreloader } from "src/components/base/components/FullScreenPreloader";
import { jwtDecode } from "jwt-decode";
import { TUserData } from "src/shared/types/globalStotre.types";
import { throttleTime } from "src/utils/utils";

export function InitialSessionLoaderProvider(props: {
  children: React.ReactNode;
}) {
  const teamConfig = useTeamConfig();
  const { setGlobalState } = useGlobalStore();
  const sessionStorage = useStorageCache(constants.storage.session);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (isLoaded) return;
    const session = sessionStorage.get(teamConfig.TEAM_SCHEMA);
    throttleTime(0, () => {
      const user = session ? (jwtDecode(session) as TUserData) : null;
      if (session) setGlobalState({ session, user });
      setIsLoaded(true);
    });
  });

  if (isLoaded) return props.children;
  return <FullScreenPreloader />;
}
